import { createAction } from 'redux-actions';

export const fetchAllRoles = createAction('FETCH_ALL_ROLES');
export const fetchAllRolesSuccess = createAction('FETCH_ALL_ROLES_SUCCESS');
export const fetchAllRolesFailure = createAction('FETCH_ALL_ROLES_FAILURE');
